package er.prateek.crossly.persistence

import com.russhwolf.settings.Settings

private const val KEY_PUZZLES_LIFETIME = "ads_puzzles_completed_lifetime"
private const val KEY_PUZZLES_SINCE_INTERSTITIAL = "ads_puzzles_since_interstitial"
private const val KEY_LAST_INTERSTITIAL_AT = "ads_last_interstitial_at"
private const val KEY_DAY = "ads_day_key"
private const val KEY_INTERSTITIALS_TODAY = "ads_interstitials_today"
private const val KEY_REWARDED_TODAY = "ads_rewarded_today"

class SettingsAdsPrefsStore(
    private val settings: Settings,
) : AdsPrefsStore {

    override fun load(): AdFrequencyState {
        val defaults = AdFrequencyState()
        return AdFrequencyState(
            puzzlesCompletedLifetime = settings.getInt(KEY_PUZZLES_LIFETIME, defaults.puzzlesCompletedLifetime),
            puzzlesSinceLastInterstitial = settings.getInt(
                KEY_PUZZLES_SINCE_INTERSTITIAL,
                defaults.puzzlesSinceLastInterstitial,
            ),
            lastInterstitialEpochMs = settings.getLong(KEY_LAST_INTERSTITIAL_AT, defaults.lastInterstitialEpochMs),
            dayKey = settings.getString(KEY_DAY, defaults.dayKey),
            interstitialsToday = settings.getInt(KEY_INTERSTITIALS_TODAY, defaults.interstitialsToday),
            rewardedToday = settings.getInt(KEY_REWARDED_TODAY, defaults.rewardedToday),
        )
    }

    override fun save(state: AdFrequencyState) {
        settings.putInt(KEY_PUZZLES_LIFETIME, state.puzzlesCompletedLifetime)
        settings.putInt(KEY_PUZZLES_SINCE_INTERSTITIAL, state.puzzlesSinceLastInterstitial)
        settings.putLong(KEY_LAST_INTERSTITIAL_AT, state.lastInterstitialEpochMs)
        settings.putString(KEY_DAY, state.dayKey)
        settings.putInt(KEY_INTERSTITIALS_TODAY, state.interstitialsToday)
        settings.putInt(KEY_REWARDED_TODAY, state.rewardedToday)
    }
}
